export default "__VITE_ASSET__BpgaAgPQ__"